<div mat-dialog-title class="title_container">
  <span class="title_text">Error in submitting form</span>
</div>

@for (error of errors; track error) {
  <ul mat-dialog-content class="content_container">
    <li>
      {{ error }}
    </li>
  </ul>
}

<div mat-dialog-actions class="cta_container">
  <button mat-button (click)="close()" class="button-primary" cdkFocusInitial>CLOSE</button>
</div>
